// src/components/Navbar.jsx
import { useContext } from "react";
import { useNavigate,NavLink,useLocation } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";
import { Link } from "react-router-dom";
import AuthModal from '../auth/AuthModal';
import "../styles/Navbar.css";

export default function Navbar({ variant = "default", filtersSlot = null }) {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const isHome = variant === "home";
  const showFilters = isHome && !!filtersSlot;

  return (
    <header className="main-navbar">
      <div className="main-navbar__top">
        {/* LEWA STRONA – logo */}
          {/* LEWA STRONA – logo */}
          <div
            className="main-navbar__logo"
            onClick={() => navigate("/")}
            role="button"
            style={{ cursor: "pointer" }}
          >
            <img
              src="/siedzieje_logo.webp"
              alt="SieDzieje"
              className="main-navbar__logoImg"
              draggable="false"
            />
          </div>

        {/* ŚRODEK – linki (proste, lekkie) */}
      <nav className="main-navbar__links" aria-label="Nawigacja">
        <NavLink
          to="/o-nas"
          className={({ isActive }) =>
            `main-navbar__link ${isActive ? "is-active" : ""}`
          }
        >
          <i className="bi bi-info-circle me-2" />
          {/* O nas */}
        </NavLink>
      </nav>

        {/* PRAWA STRONA – auth / user */}
        <div className="main-navbar__right">
          {!user ? (
            <>
              <button
                className="btn btn-primary btn-sm rounded-pill"
                data-bs-toggle="modal"
                data-bs-target="#authModal"
              >
                <i className="bi bi-box-arrow-in-right me-1" />
                Zaloguj się
              </button>
              {/* <button
                className="btn btn-primary btn-sm rounded-pill"
                onClick={() => navigate("/register")}
              >
                <i className="bi bi-person-plus me-1" />
                Zarejestruj
              </button> */}
            </>
          ) : (
            <div className="nav-profile-dropdown">
              <button
                className="btn btn-light btn-sm rounded-pill d-flex align-items-center gap-2 dropdown-toggle"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded="false"
              >
                {user.profile_picture ? (
                  <img
                    src={user.profile_picture}
                    alt="avatar"
                    className="rounded-circle"
                    style={{
                      width: "24px",
                      height: "24px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <i className="bi bi-person-circle fs-5 text-primary" />
                )}
                <span className="fw-semibold">{user.username}</span>
              </button>
              <ul className="dropdown-menu dropdown-menu-end shadow-sm glass">
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => navigate("/profile")}
                  >
                    <i className="bi bi-person me-2" />
                    Mój profil
                  </button>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => navigate("/profile/settings")}
                  >
                    <i className="bi bi-gear me-2" />
                    Ustawienia konta
                  </button>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <button
                    className="dropdown-item text-danger"
                    onClick={logout}
                  >
                    <i className="bi bi-box-arrow-right me-2" />
                    Wyloguj się
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* DODATKOWE ELEMENTY POD NAV – np. filtry tylko na stronie głównej */}
      {showFilters && (
        <div className="main-navbar__filters">
          {filtersSlot}
        </div>
      )}
      <AuthModal />
    </header>
    

  );
}
